<div class="request-list-component" [ngClass]="{'inDetail': !fullView}">
  <div class="pinner-bkg" *ngIf="isLoading">
    <div class="pinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div *ngIf="dataSource && !isLoading">
    <mat-table #table [dataSource]="dataSource">
      <ng-container matColumnDef="idCheck">
        <mat-header-cell *matHeaderCellDef>

        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="request-name-cell">
          <mat-icon *ngIf="element.status == 'REJECTED'" color="warn">indeterminate_check_box</mat-icon>
          <mat-icon *ngIf="element.status == 'APPROVED'" class="check-approved">check_box</mat-icon>
          <mat-icon *ngIf="element.status != 'APPROVED' && element.status != 'REJECTED'">check_box_outline_blank</mat-icon>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="requestName">
        <mat-header-cell *matHeaderCellDef>
          Tên Đề Xuất
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="request-name-cell">
          <div class="request-name-wrapper request-name-wrapper-details">
            <div class="request-name div-no-wrap" [ngClass]="{visited: !element.visited}">{{element.name}}</div>
            <span class="group-name">Nhóm: {{element.requestGroupName}}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Trạng Thái</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="request-status" [class]="element.status">
            <div class="txt">
              {{element.friendlyStatusName}}
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="submitter">
        <mat-header-cell *matHeaderCellDef>Người Đề Xuất</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="request-submitter">
            <div class="submitter-avatar">
              <one-avatar size="32" [imageUrl]="element.submitterInfo.avatarUrl"></one-avatar>
            </div>
            <div class="submitter-fullname">
              {{element.submitterInfo.fullName}}
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="approvers">
        <mat-header-cell *matHeaderCellDef>Người Xét Duyệt</mat-header-cell>
        <mat-cell class="approver-container" *matCellDef="let element">
          <div class="request-approvers">
            <div class="approver-avatar" *ngFor="let approver of element.approverInfos">
              <div [title]="approver.fullName">
                <one-avatar size="32" [imageUrl]="approver.avatarUrl"></one-avatar>
              </div>
              <mat-icon class="approve-marked" style="" *ngIf="approver.done > 0" [ngClass]="{rejected: approver.done == 2}">check_circle</mat-icon>
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="submitDate">
        <mat-header-cell *matHeaderCellDef>Ngày Đề Xuất</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{element.submitDate}}
        </mat-cell>
      </ng-container>
      <!-- <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>Công Cụ</mat-header-cell>
        <mat-cell *matCellDef="let element">
        </mat-cell>
      </ng-container> -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" class="req-item"
        [class.active]="activeRequestId == row.id"
        (click)="gotoRequestDetails(row)"></mat-row>
    </mat-table>
  </div>
  <div class="paginition" *ngIf="pageInfo.hasPage">
    <mat-paginator [length]="pageInfo.total" [pageSize]="pageInfo.pageSize" [pageSizeOptions]="pageInfo.options"
      (page)="onPageChanged($event)">
    </mat-paginator>
  </div>
</div>
